import {Component, OnInit, Input} from '@angular/core';
import {CompanyCustomFormVM} from "../../models/CompanyCustomFormVM.model";
import {MatDialog} from "@angular/material"
import {CompanyCustomFormDialogComponent} from "./companyCustomForm-dialog.component";
import {CompanyService} from "../../services/company-service/company-service";
import {CompanyCustomerFormDataVM} from "../../models/CompanyCustomerFormDataVM.model";
import {CompanyCustomerVM} from "../../models/CompanyCustomerVM.model";


@Component({
  selector: 'rw-company-custom-form',
  template: require('./companyCustomForm.component.html'),
  styles: [require('./companyCustomForm.style.css')]
})

export class CompanyCustomFormComponent implements OnInit {
  @Input() companyCustomFormList: CompanyCustomFormVM[];
  @Input() companyCustomer: CompanyCustomerVM;
  customFormDataList = [];

  constructor(public dialog: MatDialog,
              private companyService: CompanyService) {
  }

  ngOnInit(): void {
    this.companyService.getCompanyCustomFormDataByCompanyCustomerId(this.companyCustomer.id).subscribe(getRes => {
      this.customFormDataList = getRes;
    })
  }

  openCustomFormDialog(form, editMode?: boolean) {
    let formId = form.id;
    if (editMode) {
      formId = form.companyCustomFormId;
      const dialogRef = this.dialog.open(CompanyCustomFormDialogComponent, {
        width: '80vw',
        height:'auto',
        data: {id: form.id, title: form.title, fieldsObj: form.intakeDataDTO}
      });

      dialogRef.afterClosed().subscribe((companyCustomerFormData: CompanyCustomerFormDataVM) => {
        if (companyCustomerFormData) {
          this.customFormDataList = [];
          companyCustomerFormData.companyCustomForm = form.companyCustomForm;
          companyCustomerFormData.id = form.id;
          companyCustomerFormData.companyCustomer = this.companyCustomer;
          if (companyCustomerFormData) {
            this.save(companyCustomerFormData);
          }
        }
      })
    } else {
      this.companyService.getCompanyCustomFormDataByFormId(formId).subscribe(res => {
        const dialogRef = this.dialog.open(CompanyCustomFormDialogComponent, {
          width: '80vw',
          height:'auto',
          data: {id: form.id, title: form.title, fieldsObj: res.intakeDataDTO}
        });

        dialogRef.afterClosed().subscribe((companyCustomerFormData: CompanyCustomerFormDataVM) => {
          if (companyCustomerFormData) {
            this.customFormDataList = [];
            companyCustomerFormData.companyCustomForm = form;
            companyCustomerFormData.companyCustomer = this.companyCustomer;
            if (companyCustomerFormData) {
              this.save(companyCustomerFormData);
            }
          }
        });
      })
    }

  }

  save(companyCustomerFormData) {
    this.companyService.saveCompanyCustomFormData(companyCustomerFormData).subscribe(saveRes => {

      this.companyService.getCompanyCustomFormDataByCompanyCustomerId(saveRes.companyCustomerId).subscribe(getRes => {
        this.customFormDataList = getRes;
      })
    })
  }

  deleteFormData(formId) {
    this.companyService.deleteCompanyCustomFormDataById(formId).subscribe(res => {
      this.ngOnInit();
    })
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/company-custom-form/companyCustomForm.component.ts